
import Headroom from 'headroom.js';

export default class Navigation {

	constructor() {

		this.el = {
			nav: document.querySelector('[data-navigation]'),
			hamburger: document.querySelectorAll('.hamburger')
		};

		this.headroom = new Headroom(this.el.nav, {
			offset: window.location.pathname == '/' ? 200 : 0
		});

		//

		this.headroom.init();
		this.addListeners();
	}

	addListeners() {
		this._onHamburgerClick = this._onHamburgerClick.bind(this);
		for (let btn of this.el.hamburger) {
			btn.addEventListener('click', this._onHamburgerClick);
		}
	}

	//

	_onHamburgerClick(e) {
		e.preventDefault();
		this.el.nav.classList.toggle('is-active');
		for (let btn of this.el.hamburger) {
			btn.classList.toggle('is-active');
		}
	}
}
